// stores/auth.js
import { defineStore } from 'pinia'
import { ref } from 'vue'
import apiClient from '../config/api'

// Database credentials configuration
// Akun CS yang sama dipakai untuk semua cabang (auto-login halaman feedback publik).
const CS_ACCOUNT = {
  login: 'cs@pitcar.co.id',
  password: 'pitcar123$%^'
}

const DB_CREDENTIALS = {
  'pitcar1': CS_ACCOUNT,
  'pitcar_otokits_cilacap': CS_ACCOUNT,
  'pitcar_purbalingga': CS_ACCOUNT,
  'pitcar_tegal': CS_ACCOUNT,
  'pitcar_batam': CS_ACCOUNT,
  'pitcar_accessories': CS_ACCOUNT
}

export const useAuthStore = defineStore('auth', () => {
  const user = ref(null)
  const isAuthenticated = ref(false)
  const currentDatabase = ref(null)
  const loginError = ref(null)

  const autoLogin = async (database) => {
    try {
      loginError.value = null
      
      // Validate database
      if (!database) {
        throw new Error('Database parameter is required')
      }

      // Get credentials for the database
      const credentials = DB_CREDENTIALS[database.toLowerCase()]
      if (!credentials) {
        throw new Error('Database tidak dikenali')
      }

      // Attempt login
      return await login(database, credentials.login, credentials.password)
    } catch (error) {
      loginError.value = error.message
      throw error
    }
  }


  const login = async (database, login, password) => {
    try {
      const response = await apiClient.post('/web/session/authenticate', {
        jsonrpc: '2.0',
        method: 'call',
        params: {
          db: database,
          login,
          password
        }
      })

      // Handle session ID
      const sessionId = response.headers['x-openerp-session-id']
      if (sessionId) {
        localStorage.setItem('sessionId', sessionId)
      }

      if (response.data.error) {
        throw new Error(response.data.error.data?.message || 'Authentication failed')
      }

      const userData = response.data.result
      
      // Store essential data in localStorage
      localStorage.setItem('uid', userData.uid)
      localStorage.setItem('username', userData.username)
      localStorage.setItem('database', database)
      
      // Update state
      user.value = userData
      isAuthenticated.value = true

      return userData
    } catch (error) {
      clearSession()
      throw error
    }
  }

  const logout = async () => {
    try {
      // Attempt to call logout API
      await apiClient.post('/web/session/destroy', {
        jsonrpc: '2.0',
        method: 'call'
      })
    } catch (error) {
      console.error('API logout error:', error)
      // Continue with cleanup even if API call fails
    } finally {
      // Always clear local session
      clearSession()
    }
  }


  const clearSession = () => {
    user.value = null
    isAuthenticated.value = false
    localStorage.clear()
  }

  return {
    user,
    isAuthenticated,
    currentDatabase,
    loginError,
    login,
    autoLogin,
    logout
  }
})